import { Button } from '@material-ui/core';
import { useContext } from 'react';
import { CustomContext } from '../page';

export default function SessionQuestions(params) {
  const { setShowQuestionsPopup } = useContext(CustomContext);
  return (
    <Button onClick={() => setShowQuestionsPopup(params.data)}>
      {params.data.noOfQuestions || 0}
    </Button>
  );
}
